import React, { useState } from "react";
import { TiTick } from "react-icons/ti";
import BannerSideImage from "../../assets/images/Graphic-designer-working.avif";
import BannerImage from "../../assets/images/graphic-design-banner.avif";
import ourMission from "../../assets/images/the-search-engine-Google-opened-on-a-laptop-screen.webp";
import UIUXPortfolio from "../../assets/images/ui-ux-portfolio.webp";
import UIUXService from "../../assets/images/ui-ux-service.webp";
import UIUXByApptalyst from "../../assets/images/UI-UX-by-Apptalyst.avif";
import ApptalystBranding from "../../assets/images/Branding-by-Apptalyst.avif";
import SwiperComponent from "../../components/SwiperComponent";
import "../../App.css";
import TechStackAnimation from "../../components/TechStackAnimation";
import CustomBanner from "../../components/CustomBanner";
import FAQSection from "../../components/FAQSection";
import {
  SearchEngineOptimization,
  SocialMediaMarketing,
} from "./AnimationTechStacks";
import { motion } from "framer-motion";
import { faqData, process } from "./DigitalMarketingData";
import CustomTabs from "../../components/CustomTabs";
import { techStacks } from "./TabsTechStacks";
import GetAQuoteButton from "../../components/GetAQuoteButton";
import { Head } from "vite-react-ssg";
import FrostedContainer from "../../components/FrostedContainer";

const GraphicAndUIUXDesigning = () => {
  return (
    <>
      <Head>
        <title>Hire a graphic designer | Great Falls, VA</title>
        <meta
          name="description"
          content="Professional design services for crafting visual identities and experiences. Creative logo designs, branding, web designs and mobile app prototyping."
        />
        <link
          rel="canonical"
          href="https://apptalyst.com/graphic-and-ui-ux-designing"
        />
      </Head>
      <CustomBanner 
        bgImg={BannerImage}
                    customHeight={true}
        className="h-full  "
        BannerImageAlt="A low-fidelity UI/UX design showing the skeleton, important components and work-flow of a website."
      >             <div className="flex justify-start flex-start ">
 
        <FrostedContainer>

            
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
          >
            <h1 className="text-[30px] md:text-[38px] lg:text-[47px] xl:text-[52px] 2xl:text-[67px]  leading-[1.2] font-bold ">
              Graphic and UI/UX Designing
            </h1>
            
          </motion.div>

          <ul className="space-y-2 ">
            <li className="flex items-start  md:items-center text-base md:text-lg">
              <span className="text-dark mr-2 bg-[#FFC067] rounded-full p-0.5 mt-0.5 md:mt-0">
                <TiTick />
              </span>
              Crafting visual brand identities and establishing consistent brand
              guidelines.
            </li>
            <li className="flex items-start  md:items-center text-base md:text-lg">
              <span className="text-dark mr-2 bg-[#FFC067] rounded-full p-0.5 mt-0.5 md:mt-0">
                <TiTick />
              </span>
              Promotional content and marketing collaterals for businesses of
              all sizes.
            </li>
            <li className="flex items-start  md:items-center text-base md:text-lg">
              <span className="text-dark mr-2 bg-[#FFC067] rounded-full p-0.5 mt-0.5 md:mt-0">
                <TiTick />
              </span>
              Complete graphic design and self-publishing assistance for indie
              authors.
            </li>
          </ul>
          <div className="">
            <GetAQuoteButton title='Get Started' text="Get Started" />
          </div>
        </FrostedContainer>
          
        </div>
       </CustomBanner>

      <section className="container space-y-20 md:space-y-32 mb-20 md:mb-32 mt-32 ">
           <div className=" space-y-20 md:space-y-32 mb-20 md:mb-32">
            <div className="flex flex-col space-y-10">
              <motion.h2
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
                viewport={{ once: true, amount: 0.3 }}
                className="text-[30px] md:text-[35px] lg:text-[40px] xl:text-[45px] 2xl:text-[50px] font-bold text-center md:text-start text-dark self-center font-butler"
              >
                Artisanal Graphic Design Services
              </motion.h2>
              <div className="flex flex-col lg:flex-row justify-center items-center space-y-10 lg:space-y-0  lg:space-x-8 sm:px-10   lg:px-0">
                <div className="space-y-10 w-full lg:w-7/12 ">
                  <ul className="space-y-5 lg:space-y-2 text-lg px-2 md:px-0">
                    <li className="flex items-start text-dark  space-x-2">
                      <span className="text-dark  bg-[#FFC067] rounded-full p-0.5  mt-0.5">
                        <TiTick />
                      </span>

                      <div>
                        <h3 className="inline font-bold m-0 text-[18px]">
                          Logo designing:{" "}
                        </h3>{" "}
                        <span className="text-base leading-[1.625rem]">
                          We create the full spectrum of logo designs, from
                          sophisticated text-based logos (monograms and
                          wordmarks) with custom typography to elegant pictorial
                          marks, abstract marks, and memorable mascots. Every
                          design is delivered in vector format, ensuring perfect
                          creative fulfillment and future-proofing brand
                          evolution.
                        </span>
                      </div>
                    </li>
                    <li className="flex items-start text-dark  space-x-2">
                      <span className="text-dark  bg-[#FFC067] rounded-full p-0.5  mt-0.5">
                        <TiTick />
                      </span>

                      <div>
                        <h3 className="inline font-bold m-0 text-[18px]">
                          Animations & Motion Graphics:
                        </h3>{" "}
                        <span className="text-base leading-[1.625rem]">
                          We bring brands to life with dynamic animations. We
                          specialize in engaging motion graphics, lightweight
                          Lottie files for web and mobile, classic GIFs,
                          explanatory whiteboard videos, and immersive 2D/3D
                          animations.
                        </span>
                      </div>
                    </li>
                    <li className="flex items-start text-dark  space-x-2">
                      <span className="text-dark  bg-[#FFC067] rounded-full p-0.5  mt-0.5">
                        <TiTick />
                      </span>

                      <div>
                        <h3 className="inline font-bold m-0 text-[18px]">
                          {" "}
                          Branding Essentials:{" "}
                        </h3>{" "}
                        <span className="text-base leading-[1.625rem]">
                          We solidify your brand identity with professionally
                          designed collateral, including polished business
                          cards, infographics, persuasive pitch decks and
                          compelling proposals.
                        </span>
                      </div>
                    </li>
                    <li className="flex items-start text-dark space-x-2">
                      <span className="text-dark  bg-[#FFC067] rounded-full p-0.5  mt-0.5">
                        <TiTick />
                      </span>

                      <div>
                        <h3 className="inline font-bold m-0 text-[18px]">
                          {" "}
                          Marketing materials:{" "}
                        </h3>{" "}
                        <span className="text-base leading-[1.625rem]">
                          We help capture your audience's attention with a range
                          of marketing materials, such as informative brochures,
                          product catalogs, insightful reports, engaging
                          newsletters, and eye-catching flyers and posters.
                        </span>
                      </div>
                    </li>
                    <li className="flex items-start text-dark space-x-2">
                      <span className="text-dark  bg-[#FFC067] rounded-full p-0.5  mt-0.5">
                        <TiTick />
                      </span>

                      <div>
                        <h3 className="inline font-bold m-0 text-[18px]">
                          {" "}
                          For Authors & Publishers:{" "}
                        </h3>{" "}
                        <span className="text-base leading-[1.625rem]">
                          {" "}
                          We offer dedicated services for independent authors,
                          guaranteeing original, human-created illustrations for
                          stunning book covers, unique character art, and
                          meticulous book formatting.
                        </span>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="w-full lg:w-5/12 flex  justify-center xl:justify-center items-start xl:items-center ">
                  <img
                    // loading='lazy'
                    src={ApptalystBranding}
                    alt="Branding portfolio item by Apptalyst, consisting of a logo design and it’s mockup over a hand bag."
                    className="rounded  w-10/12 lg:w-full h-auto "
                  />
                </div>
              </div>
            </div>
            <div className="flex flex-col space-y-10">
              <motion.h2 
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
                viewport={{ once: true, amount: 0.3 }}
                className="text-[30px] md:text-[35px] lg:text-[40px] xl:text-[45px] 2xl:text-[50px] font-bold text-center md:text-start text-dark mx-auto font-butler"
              >
                Expert UI/UX Design Services
              </motion.h2>
              <div className="flex flex-col lg:flex-row justify-center items-center space-y-10 lg:space-y-0  lg:space-x-8 sm:px-10   lg:px-0">
                <div className="space-y-10 w-full lg:w-7/12 ">
                  <ul className="space-y-5 lg:space-y-2 text-lg px-2 md:px-0">
                    <li className="flex items-start text-dark  space-x-2">
                      <span className="text-dark  bg-[#FFC067] rounded-full p-0.5  mt-0.5">
                        <TiTick />
                      </span>

                      <div className="">
                        <h3 className="inline font-bold m-0 text-lg">
                          User Interface (UI) Design:
                        </h3>{" "}
                        <span className="text-base leading-[1.625rem]">
                          We craft modern, clean, and high-performing user
                          interfaces. Our work involves designing beautiful
                          screens and reusable components for engaging landing
                          pages, websites, and mobile applications, which
                          delight users at first glance.
                        </span>
                      </div>
                    </li>

                    <li className="flex items-start text-dark space-x-2">
                      <span className="text-dark  bg-[#FFC067] rounded-full p-0.5  mt-0.5">
                        <TiTick />
                      </span>

                      <div>
                        <h3 className="inline font-bold m-0 text-lg">
                          User Experience (UX) Design:{" "}
                        </h3>{" "}
                        <span className="text-base leading-[1.625rem]">
                          Our process is centered on creating a product that is
                          both convenient and enjoyable to use. We achieve this
                          by developing functional prototypes to map user
                          workflows, defining intuitive interactions and
                          animations, and conducting early-stage usability
                          testing. This ensures the final product is a lovable
                          and seamless experience for your end-users.{" "}
                        </span>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="w-full lg:w-5/12 flex   justify-center items-start xl:items-center ">
                  <img
                    src={UIUXByApptalyst}
                    alt="A UI/UX design of a mobile application with prototyping connections showing user flow."
                    className="rounded  w-10/12 lg:w-full h-auto "
                  />
                </div>
              </div>
            </div>
          </div>
 
        <div className=" space-y-20 md:space-y-32 mb-20 md:mb-32">
          <CustomTabs techStacks={techStacks} title="Tools we use " />

          <FAQSection faqData={faqData} />
        </div>
      </section>
    </>
  );
};

export default GraphicAndUIUXDesigning;
